import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import {Box, CircularProgress, Divider, Popover, Tooltip, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import React, {useCallback} from "react";
import protect from "../../../../shared/utils/guard";
import Grid from "@material-ui/core/Grid";
import HelpIcon from "@material-ui/icons/Help";

const useStyles = makeStyles(() => ({
    hasIcon: {
        marginLeft: "0.5em"
    },
    menuItem: {
        padding: "1em"
    }
}))

const ClickableDropdown = ({setAnchorEl, ...props}) => {
    const classes = useStyles();

    const handleClose = useCallback(() => {
        setAnchorEl(null);
    }, [setAnchorEl])

    const open = Boolean(props.anchorEl);

    return (
        <Popover
            open={open}
            anchorEl={props.anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <MenuList id="menu-list-grow">
                {props.menuItems.map((item, idx) => {
                    if (item.text === "divider") {
                        if (item.roles) {
                            const Hoc = protect(item.roles)(Divider)
                            return (<Hoc key={"divider-" + idx}/>)
                        } else {
                            return (<Divider key={"divider-" + idx}/>)

                        }
                    } else if (item.text.toLowerCase().includes("csv")) {
                        return (
                            <MenuItem onClick={item.handleClick}
                                      key={"menu-item-" + idx}
                                      className={classes.menuItem}
                                      disabled={item.disabled || item.loadingCsv}>
                                <Grid container justifyContent='space-between' alignItems='center'>
                                    <Typography variant="body2">{item.text}</Typography>
                                    {item.loadingCsv && <CircularProgress size={20}/>}
                                </Grid>
                            </MenuItem>
                        );
                    } else if (item.hideItem) {
                        return null
                    } else {
                        const Hoc = protect(item.roles)(MenuItem);
                        return (
                            item.showTooltip ?
                        <Box style={{display:"flex",flexDirection:"row", alignItems:"center"}} key={"menu-item-" + idx}>
                             <Hoc key={"menu-item-" + idx}
                                 className={classes.menuItem}
                                 onClick={() => {
                                     item.handleClick();
                                     handleClose();
                                 }}
                                 disabled={item.disabled}>
                                {item.icon ? item.icon : null}
                                <Typography className={item.icon ? classes.hasIcon : ""} variant="body2">
                                    {item.text}
                                    {item.tooltipText ? <Tooltip arrow
                                                                 placement="bottom-end"
                                                                 title={item.tooltipText}>
                                        <HelpIcon color="primary" fontSize="small"/>
                                    </Tooltip> : null}
                                </Typography>
                            </Hoc>
                            {item.showTooltip ?
                            <Typography className={item.icon ? classes.hasIcon : ""} variant="body2">
                                    <Tooltip arrow
                                            placement="bottom-end"
                                            title={item.showTooltipText}>
                                    <HelpIcon color="primary" fontSize="small"/>
                                </Tooltip>
                            </Typography>
                             : null}
                        </Box> :
                            <Hoc key={"menu-item-" + idx}
                            className={classes.menuItem}
                            onClick={() => {
                                item.handleClick();
                                handleClose();
                            }}
                            disabled={item.disabled}>
                           {item.icon ? item.icon : null}
                           <Typography className={item.icon ? classes.hasIcon : ""} variant="body2">
                               {item.text}
                               {item.tooltipText ? <Tooltip arrow
                                                            placement="bottom-end"
                                                            title={item.tooltipText}>
                                   <HelpIcon color="primary" fontSize="small"/>
                               </Tooltip> : null}
                           </Typography>
                       </Hoc>
                        )
                    }
                })}
            </MenuList>
        </Popover>
    )
}


export default ClickableDropdown;
